module.exports = "pegasus_template/assets/themelp1/large/40.png";